module.exports = __webpack_public_path__ + "static/media/994389.83b96f49.png";